import React, { useEffect, useMemo } from 'react';
import gsap from 'gsap';

import { sections } from '../../../common/config';
import useScrollStore from '../../../common/store/useScrollStore';

const useAnimation = (ref: React.RefObject<SVGSVGElement>) => {
  const threshold = sections.height.landing / 100 * window.innerHeight;

  const defaults = {
    duration: 0.25,
    ease: "power2.out"
  };

  useEffect(() => useScrollStore.subscribe(state => {
    if (-state.position > threshold) {
      gsap
        .to(ref.current, { duration: 0.1, display: "block" })
        .eventCallback("onComplete", () => { gsap.to(ref.current, { ...defaults, opacity: 1 }) });
    } else {
      gsap
        .to(ref.current, { ...defaults, opacity: 0 })
        .eventCallback("onComplete", () => { gsap.to(ref.current, { duration: 0, display: "none" }) });
    }
  }), []);


}

export default useAnimation;